import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useFaceplateMessages = (deviceId, startDate, endDate) => {
  const { faceplateMessages, setFaceplateMessages, areFaceplateMessagesLoaded, setAreFaceplateMessagesLoaded } = useStoreContext()

  useEffect(() => {
    setFaceplateMessages(null)
    setAreFaceplateMessagesLoaded(false)
    Api.DeviceAggregator.getFaceplateMessages(deviceId, startDate, endDate)
      .then((res) => {
        if (res) {
          setAreFaceplateMessagesLoaded(true)
          setFaceplateMessages(res)
        }
      })
      .catch(() => {
        setAreFaceplateMessagesLoaded(true)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId, startDate, endDate])

  return { faceplateMessages, areFaceplateMessagesLoaded }
}

export default useFaceplateMessages
